<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-row no-gutters>
        <image-row :title="topTitle" config="page-apps" />
      </v-row>
      <v-row no-gutters justify="center" class="my-5">
        <div class="apps-wrapper">
          <div class="apps-title-wrapper">
            <span class="apps-title">{{ categoriesTitle }}</span>
          </div>
          <div class="categories-buttons-wrapper">
            <v-row no-gutters justify="center" :class="isMobile ? '' : 'my-5'">
              <v-col cols="12" align="center">
                <v-btn v-for="category in categories" :key="category.id" height="54" :ripple="false" :class="currentCategory === category.id ? 'categories-button selected' : 'categories-button'" @click="onCategoryClicked(category.id)">
                  <span class="categories-button-text">{{ category.name }}</span>
                </v-btn>
              </v-col>
            </v-row>
          </div>
          <div class="apps-cards-wrapper">
            <v-row class="my-5 apps-card-grid" no-gutters justify="center">
              <div class="apps-card-column" v-for="(app, index) in showedApps" :key="index">
                <div class="apps-card">
                  <div class="apps-card-icon-wrapper">
                    <div class="apps-card-icon">
                      <img :src="'https://storage.googleapis.com/mwm-website-v2-content/apps/app-icon-' + app.key + '.png'" >
                    </div>
                  </div>
                  <div class="apps-card-title-wrapper">
                    <span class="apps-card-title">{{ app.title }}</span>
                  </div>
                  <div class="apps-card-text-wrapper">
                    <span class="apps-card-text">{{ app.baseline }}</span>
                  </div>
                  <div class="apps-card-badges-wrapper">
                    <div class="apps-card-badges">
                      <v-row no-gutters justify="center">
                        <v-col cols="6" v-if="app.iosId !== null">
                          <v-img eager height="38" contain @click="openStore('ios', app.iosId)" class="app-card-badge" src="https://storage.googleapis.com/mwm-website-v2-content/apps/download_appstore.svg" />
                        </v-col>
                        <v-col cols="6" v-if="app.androidId !== null">
                          <v-img eager height="38" contain @click="openStore('android', app.androidId)" class="app-card-badge" src="https://storage.googleapis.com/mwm-website-v2-content/apps/download_playstore.svg" />
                        </v-col>
                      </v-row>
                    </div>
                  </div>
                </div>
              </div>
            </v-row>
          </div>
        </div>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import SizeHolder from '@/mixins/SizeHolder.vue';

import ImageRow from './components/ImageRow.vue';

export default {
  mixins: [SizeHolder],
  components: {
    'image-row': ImageRow,
  },
  data: () => ({
    topTitle: 'For every need, an app.',
    categoriesTitle: 'Our apps',

    androidRoot: 'https://play.google.com/store/apps/details?id=',
    iosRoot: 'https://apps.apple.com/app/id',

    currentCategory: 'all',
    categories: [
      { id: 'all', name: 'All' },
      { id: 'music_production', name: 'Production' },
      { id: 'music_utilities', name: 'Utilities' },
      { id: 'music_gaming', name: 'Gaming' },
      { id: 'music_learning', name: 'Learning' },
    ],
    applicationsByCategory: {
      music_production: [
        { key: 'edjing-mix', title: 'edjing Mix', iosId: '493226494', androidId: 'com.edjing.edjingdjturntable', baseline: 'Remix your songs & make music' },
        { key: 'edjing-pro', title: 'edjing Pro ', iosId: '1022000001', androidId: 'com.djit.apps.edjing.expert', baseline: 'Remix music & perform live' },
        { key: 'mixfader', title: 'Mixfader DJ', iosId: '1053941771', androidId: 'com.djit.apps.edjing.scratch', baseline: 'Digital vinyl for scratching' },
        { key: 'beatsnap', title: 'Beat Snap 2', iosId: '1437797871', androidId: null, baseline: 'Music Maker' },
        { key: 'drum-machine', title: 'Drum Machine ', iosId: '1435908315', androidId: null, baseline: 'Simply the best beat maker tool' },
        { key: 'beatwave', title: 'Beatwave 3', iosId: '1463548238', androidId: null, baseline: 'Music made easy' },
      ],
      music_utilities: [
        { key: 'tuner', title: 'Tuner', iosId: '1438248122', androidId: 'com.mwm.guitartuner', baseline: 'Tuner & chords tabs for guitar' },
        { key: 'metronome', title: 'Metronome', iosId: '1439767245', androidId: 'com.mwm.metronome', baseline: 'The metronome app you have been waiting for' },
        { key: 'stream', title: 'Stream', iosId: null, androidId: 'com.djit.apps.stream', baseline: 'Music Player for Youtube' },
        { key: 'equalizer', title: 'Equalizer+', iosId: '777191669', androidId: 'com.djit.equalizerplusforandroidfree', baseline: 'Bass Booster & Music Equalizer' },
        { key: 'bass-booster', title: 'Bass Booster', iosId: '927920917', androidId: 'com.djit.bassboostforandroidfree', baseline: 'More bass, more sensations' },
        { key: 'taomix', title: 'TaoMix 2', iosId: '1032493819', androidId: null, baseline: 'Relax and get better sleep' },
      ],
      music_gaming: [
        { key: 'piano', title: 'Piano', iosId: '1360309966', androidId: 'com.mwm.piano', baseline: 'Become a virtuoso pianist' },
        { key: 'guitar', title: 'Guitar', iosId: '1365011081', androidId: 'com.mwm.guitar', baseline: 'Guitar playing has never been so simple' },
      ],
      music_learning: [
        { key: 'drums', title: 'Drums', iosId: '1381436705', androidId: 'com.mwm.drum', baseline: 'Learn to play like a real drummer' },
        { key: 'bmp', title: 'Beat Maker Pro', iosId: '1362013798', androidId: 'com.mwm.sampler', baseline: 'The best way to become a great beat maker' },
      ],
    },
    allApps: []
  }),
  methods: {
    buildAllApps () {
      let apps = [];
      Object.entries(this.applicationsByCategory).forEach((entry) => {
        apps = apps.concat(entry[1]);
      })
      this.allApps = apps;
    },
    onCategoryClicked (category) {
      this.currentCategory = category;
    },
    openStore (type, appID) {
      const url = type === 'android' ? this.androidRoot + appID : this.iosRoot + appID;
      const win = window.open(url, '_blank');
      win.focus();
    },
  },
  computed: {
    showedApps () {
      if (this.currentCategory === 'all') {
        return this.allApps;
      }
      return this.applicationsByCategory[this.currentCategory];
    }
  },
  mounted () {
    this.buildAllApps();
  }
};
</script>

<style scoped lang="scss">
@media (max-width: 960px) {
  .apps-card-grid {
    grid-template-columns: repeat(2, 1fr)!important;
    grid-column-gap: 30px!important;
  }

  .categories-button {
    margin: 0.5rem!important;
    width: 130px!important;
  }
}

@media (max-width: 760px) {
  .apps-card-grid {
    grid-template-columns: repeat(1, 1fr)!important;
    grid-column-gap: 30px!important;
  }
}

.apps-wrapper {
  width: 100%;
  height: 100%;
  text-align: center;
}

.apps-title-wrapper {
  margin-top: 5rem;
}

.apps-title {
  font-family: CenturyGothic;
  font-size: 36px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #212a39;
}

.categories-buttons-wrapper {
  margin-top: 3rem;
}

.categories-button {
  margin: 1.5rem;
  width: 200px;
  text-transform: unset;
  border-radius: 27px;
  position: relative;
  background-color: #212a39!important;
  z-index: 1;
}

.categories-button.selected {
  background-color: transparent!important;
  transition: background-color 0.5s linear;
}

.categories-button.selected:hover::before {
  opacity: 1!important;
}
.categories-button:hover::before {
  opacity: 0!important;
}

.categories-button::before {
  position: absolute;
  content: "";
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-image: -webkit-gradient(linear, left top, right top, color-stop(114%, #990cb4), color-stop(12%, #ff0067));
  background-image: linear-gradient(to right, #990cb4, #ff0067);
  z-index: -1;
  transition: opacity 0.2s linear;
  opacity: 0;
}

.categories-button.selected::before {
  opacity: 1;
}

.categories-button-text {
  font-family: CenturyGothic;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
}

.apps-cards-wrapper {
  margin-top: 2rem;
  width: 70%;
  margin-left: auto;
  margin-right: auto;
}

.apps-card-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 10px;
  grid-auto-rows: minmax(100px, auto);
}

.apps-card {
  padding: 2.5rem 1rem 1.5rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  margin-left: auto;
  margin-right: auto;
  max-width: 20rem;
  border-radius: 1.6rem;
  background-color: #ffffff;
  box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.2);
}

.apps-card-icon-wrapper {
  line-height: 1;
}

.apps-card-icon img {
  height: 6rem;
  width: auto;
  border-radius: 1.6rem;
}

.apps-card-title-wrapper {
  margin-top: 1.5rem;
}

.apps-card-title {
  font-family: CenturyGothic;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.35;
  letter-spacing: normal;
  text-align: center;
  color: #212a39;
}

.apps-card-text-wrapper {
  margin-top: 1rem;
  height: 2.75rem;
}

.apps-card-text {
  font-family: CenturyGothic;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  text-align: center;
  color: #212a39;
}

.apps-card-badges-wrapper {
  margin-top: 1rem;
}

.apps-card-badges {

}

.app-card-badge {
  cursor: pointer;
}
</style>
